import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

import cartSound from "../../assets/sounds/cartSound.mp3";

const CustomToast = ({ message, onClose }) => {
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    const audio = new Audio(cartSound);
    audio.play();

    const timeout = setTimeout(() => {
      setAnimateOut(true);
      setTimeout(() => {
        onClose();
      }, 400);
    }, 2500);

    return () => clearTimeout(timeout);
  }, [onClose]);

  return (
    <ToastWrapper $hide={animateOut} onClick={() => setAnimateOut(true)}>
      {message}
    </ToastWrapper>
  );
};

export default CustomToast;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, 1.8rem) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0) scale(1);
  }
`;

const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translate(-50%, 0) scale(1);
  }
  to {
    opacity: 0;
    transform: translate(-50%, 1.8rem) scale(0.96);
  }
`;

const ToastWrapper = styled.div`
  position: fixed;
  bottom: 10rem;
  left: 50%;
  z-index: 9990;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1rem;
  background: rgba(16, 16, 19, 0.94);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid var(--line2, rgba(255, 255, 255, 0.14));
  border-left: 3px solid var(--red, #fe5f55);
  color: var(--text, #f4f2ee);
  padding: 1.3rem 2.2rem;
  border-radius: 0.6rem;
  font-family: "Poppins-Medium";
  font-size: 1.3rem;
  letter-spacing: 0.04em;
  box-shadow: 0 1.8rem 4.2rem -1.4rem rgba(0, 0, 0, 0.85);
  animation: ${({ $hide }) => ($hide ? slideOut : slideIn)} 0.35s
    cubic-bezier(0.22, 0.72, 0.18, 1) forwards;
  height: fit-content;
  user-select: none;
  white-space: nowrap;

  &::before {
    content: "✓";
    color: var(--red, #fe5f55);
    font-weight: 700;
    font-size: 1.5rem;
  }

  @media (max-width: 400px) {
    width: max-content;
    max-width: 92vw;
    white-space: normal;
  }
`;
